import { Collection, Q } from '@nozbe/watermelondb';

import { DBServiceOptionsWithImages } from '../../types/dbService';
import { EventContactReminderModel } from '../../types/EventContactReminder';

/**
 * Read-only facade for event_contact_reminders.
 * Writes go through Event helpers or Contact.deleteByID cascade.
 */
class EventContactReminder {
    private collection: Collection<EventContactReminderModel>;
    private table = 'event_contact_reminders';

    constructor(options: DBServiceOptionsWithImages) {
        this.collection = options.database.collections.get(this.table);
    }

    getByID(id: string) {
        return this.collection.find(id);
    }

    async getByParam(param: string, value: any) {
        return this.collection.query(Q.where(param, value)).fetch();
    }
}

export default EventContactReminder;
